import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-login-title',
  standalone: true,
  templateUrl: './login-title.component.html',
  styleUrls: ['./login-title.component.less']
})
export class LoginTitleComponent {
  @Input() systemName = '';
}
